var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGt = function SvgGt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#gt_svg__a",
    id: "gt_svg__d",
    cx: 447.4,
    cy: 308.3,
    r: 16.5,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gt_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#gt_svg__a",
    id: "gt_svg__e",
    cx: 451.6,
    cy: 313,
    r: 10.9,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#gt_svg__a",
    id: "gt_svg__f",
    cx: 454.1,
    cy: 308.6,
    r: 9.8,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#gt_svg__a",
    id: "gt_svg__g",
    cx: 458.4,
    cy: 307.1,
    r: 17.4,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#gt_svg__a",
    id: "gt_svg__j",
    cx: 446,
    cy: 252.4,
    r: 13,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gt_svg__m",
    cx: 477.9,
    cy: 215.3,
    r: 0.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a50a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c0505"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gt_svg__n",
    cx: 489.1,
    cy: 210.3,
    r: 0.3,
    fx: 489.1,
    fy: 210.3,
    gradientTransform: "scale(.97707 1.02346)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt_svg__h",
    x1: 473.9,
    x2: 472.4,
    y1: 259.2,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt_svg__i",
    x1: 483.1,
    x2: 485.5,
    y1: 296.7,
    y2: 326.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b07e09",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt_svg__k",
    x1: 451.5,
    x2: 455.4,
    y1: 249.5,
    y2: 240.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gt_svg__l",
    x1: 473.3,
    x2: 475.9,
    y1: 237.2,
    y2: 270.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f9f0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b07e09"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4997d0",
    d: "M0 0h512v512H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.7 0h170.6v512H170.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.7063 0 0 .71942 -83 40.2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.4,
    d: "M452.1 377.5c2.7-.4 4.2-1.2 6-1.8m2.3-4.1a13 13 0 0 1 3 4.7m-8.1-5.1a13 13 0 0 1 3 4.2m-49.5-136.6c-1 1.6-3 2.7-4.8 3.4m-.3-.2q-.2-2.2 0-4.4m-1.9 5c0 .4.4 1.4.6 2m2.1 1-2 .3m-4-.9c0 2.6.3 5.6.5 7.9m-1.8-1q.7 1.3 1.6 1.9m-4.6 6.5q.8 1.2 1.3 4m3.7-4.7-2 1.5m1.7 4.4q-1.5 1.3-3.5 2.1m-3.8 40.4a16 16 0 0 0 4 4.7m.6 1.7a8 8 0 0 1-3-1m4.4 8.5 1.7 1m-.4 3.4q1.8 1.4 3.7 3.9m-1.4 2.8q2.1.5 3.2 1m-1 2.5h2m1.3-5.3-.5 4.2m1 1.6.4-1.6m4.7 6-.1 3.2m39.2 27.9-1.2 1.6m-2.4-3.9-.7-1.8"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M486.1 385a8 8 0 0 0-3.3-2.7c-7.7-4-15.4-5.9-24-7.3-2.1-.3-4.1-2.2-6.2-3.2-5-2.3-10.5-3.2-15.3-5.7-.3-.1-1.5-.8-2-1.5-2-2.2-5.5-2.9-7.6-5-8.4-7.8-17.2-15-21.8-25.5-5.6-12.7-12.5-25.8-11.6-40.2.6-9.2-.7-18.4 1.5-27 3.4-13 7.6-25.7 15.4-36.4l-1.3.8a104 104 0 0 0-15.4 36.3c-2.3 8.7-1 18-1.5 27-1 14.5 6 27.6 11.5 40.3 4.6 10.4 13.5 17.7 21.8 25.6 2.2 2 5.6 2.7 7.6 5l2 1.5c4.9 2.4 10.4 3.3 15.4 5.7 2 1 4 2.8 6 3.2a77 77 0 0 1 24.2 7.2 8 8 0 0 1 3.3 2.7l1.3-.9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.3 331.6a47 47 0 0 1-.2-23.5c6.7 13 4.5 23.7.2 23.5zm45.9 45.4a49 49 0 0 0-21.9 11.4c15.1.1 24-7.3 21.9-11.4zm7.5-4.3a60 60 0 0 1-14-26.5c15 10.9 18.9 24.3 14 26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6 372.8a55 55 0 0 1-16-22.8c15.3 8.2 20.3 20.2 16 22.8zM439 366c1-7.8-5.6-24.2-7.5-26-3 16.5 3 27.6 7.5 26zm-27.3-24.3a42 42 0 0 1 .5-21c5.5 11.7 3.3 21.2-.5 21zM398 264.9a51 51 0 0 1 21-16c-6.8 14.6-18 19.9-21 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7 259.3a52 52 0 0 1 17.4-20c-3.7 15.7-13.7 23.2-17.4 20zm27.9 99.2a55 55 0 0 1-7.3-26.4c11.2 12.5 12 25.3 7.2 26.4zM397.9 322c-7 1.1-21.4-4.6-23-6.3 14.6-3.2 24.4 2 23 6.3zm-2.2-9.7c.8-5.5 8.6-15.8 10.3-16.6-1 12-7.4 18.6-10.3 16.6zm51.3 58.6a57 57 0 0 0-26.1 13.6c18 .1 28.7-8.7 26.1-13.6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.4 331.5c4.2.2 6.4-10.4-.3-23.4a79 79 0 0 1 .3 23.4zm11.2 20a49 49 0 0 0-21.7-11.2c8.9 12.1 19.9 15.1 21.7 11.2zm-24.4-53a57 57 0 0 0-14.8-24c1.5 17.2 10.6 26.7 14.8 24zm8.4 34.3c-5-3.7-19-5.4-21-4.8 10.2 8.4 20.2 8.5 21 4.8zm-9.4-24.8a42 42 0 0 0-16.9-13.8c5.5 12.4 14.6 17 16.9 13.7zm2.8-47.6c.8-7.6-5.6-23.4-7.4-25.2-2.9 16 2.9 26.7 7.3 25.2zm4.4-14.9c2.7-6.5.8-22.4-.5-24.4-6.4 13.5-3.8 24.6.5 24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4 237.8a40 40 0 0 0 3.5-19.4c-7.2 9.7-7 18.9-3.5 19.4zm6-6.1a39 39 0 0 0 9-17.4c-9.7 7-12.2 15.8-9 17.4zm-16.1 43.2c.1.9-1-8.2-10-18.3.4 14.8 6.2 20.4 10 18.3zm32.6 85.8a53 53 0 0 0-25.8-6c12.6 10.4 24.9 10.6 25.8 6zM439 366c-4.6 1.5-10.5-9.5-7.6-26a99 99 0 0 0 7.5 26zm13.3 11c2 4.1-6.8 11.5-21.8 11.4 12-5 21.2-9.9 21.8-11.3zm7.3-4.4c4.9-2.3 1.1-15.5-14-26.4 8.6 13.2 14.5 24.6 14 26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6 372.7c4.2-2.7-.7-14.5-16-22.7 9.5 11.2 16.2 21 16 22.7zm-42.8-31c3.7.2 6-9.3.5-21 .7 11 .4 20-.5 21zM398 265c3 3.8 14-1.4 20.9-16a91 91 0 0 1-20.9 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9 259.3c3.6 3.2 13.5-4.3 17.2-20-8 11.3-15.6 19.8-17.2 20zm27.7 99.1c4.7-1.1 4-13.8-7.3-26.3 5 13.5 8 24.8 7.3 26.3zM397.7 322c1.4-4.3-8.3-9.4-22.8-6.3 12.3 2.2 22 5 22.8 6.3zm-1.9-9.6c2.9 1.8 9.1-4.7 10.3-16.7a69 69 0 0 1-10.3 16.7zM447 371c2.5 5-8 13.7-26 13.6 14.2-5.9 25.3-11.8 26-13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4 326.3a45 45 0 0 0-17-15.8c5 13.6 14.2 19.1 17 15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.4 274c4-4.7 17.5-9.2 19.6-9-8 10.5-18 12.6-19.6 9zm25.1 77.5c-1.8 4-12.7 1-21.7-11.1a84 84 0 0 0 21.7 11.1zm-24.4-53c-4.2 2.7-13.1-6.8-14.7-24 6.6 13.3 13 23.5 14.7 24zm8.4 34.3c-.7 3.7-10.7 3.6-20.8-4.7a74 74 0 0 0 20.8 4.7zm-9.5-24.9c-2.3 3.2-11.2-1.3-16.7-13.7 8.2 8 15.5 13.7 16.8 13.7zm2.8-47.6c-4.4 1.6-10.1-9-7.3-25 2.7 13.5 6 24.2 7.3 25zm4.5-14.9c-4.3.3-6.9-10.8-.5-24.3-.8 12.8-.5 23.3.5 24.3zm5-7.6c-3.4-.6-3.7-9.7 3.6-19.4a66 66 0 0 0-3.6 19.4zm6-6.1c-3.1-1.7-.7-10.4 9-17.3a66 66 0 0 0-9 17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.3 274.9c-3.9 2.1-9.6-3.5-10-18.3q7.7 17.6 10 18.3zm32.5 85.8c-.9 4.6-13.1 4.4-25.7-5.9 13.2 4.3 24.3 6.7 25.7 5.9zm-8.2-9.5A41 41 0 0 1 412 332c9 8.7 10.2 18.1 6.8 19.2zm-16.8-25c-3.6-5.8-4-20.9-3-23 8.3 11.9 7.3 22.7 3 23zm-2.7.1c-2.7 3.3-11.9-2.1-16.8-15.8a77 77 0 0 0 16.8 15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.4 274c1.6 3.6 11.4 1.5 19.5-8.9-12 6.8-16.7 9.8-19.5 8.9zm9.3 52c4.3-.3 5.3-11-3-22.8a73 73 0 0 1 3 22.9zm17 25.2c3.4-1 2.2-10.5-6.7-19.2 4.4 9.7 7.2 18 6.7 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.2 291.8c2-8.4-1.7-22.6-4.3-25.6-4.7 15.4-.2 26.6 4.3 25.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M394 293.8c-6 1.3-8.7-12-4.1-27.1 1 13.5 2.8 26.1 4 27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M392.7 293.7a53 53 0 0 1 9-24.7c2 15.8-4.5 26.3-9 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M392.8 293.6c4.5 1.6 10.9-8.8 8.9-24.6-3.5 13.3-7.5 23.8-8.9 24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M394.1 303.3a50 50 0 0 1 10.6-23.7c.8 16.2-6.3 25.9-10.6 23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M394.2 303.4c4.2 2.2 11.3-7.4 10.5-23.5-4.4 12.8-9 22.9-10.5 23.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ba1f3e",
    stroke: "#511124",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 396.8,
    cy: 251.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.2,
    cy: 245.1,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.6,
    cy: 241.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 313.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 297.1,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.2,
    cy: 334.5,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.4,
    cy: 336.4,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.7,
    cy: 367.6,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.6,
    cy: 374.7,
    r: 1.3
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.4,
    d: "M561.1 259c.7.6 1.2.8 2.3 1.9m-6.6-18.9c0-1.4-.6-3.7-.9-5m3.5 3q0 2.8-1.1 5.4m-4.2-.5q2.6 2.5 5.3 3.9m3.8 1.2q.2 3-.7 6m.4 1.5 1.3-2.3m-1.9 12.2c1.4.3 2.8 2 3.5 3.5m.5-1.3 1.6-2.2m1.7 30.8-2.4 3.4m-4 0c.8 1.4 1.6 3 2.6 4m2.5 5.9a13 13 0 0 1-4.5 4m.2 4.5c-1.1.8-2.5 3-3.7 4.7m8.4-20.2-2.1.9m-1.4-7.4 1.2 1m-9.3 37.4h-2m-2.1-1.8.6 1.6m-7.6 5.1q-.3 2.8.1 5.6m4.3-9 1 2.2m3.9-.1-2.5.3M522 365.6l-1 1.8m11.9-4q-2.2.2-4.1-.2m-5.5 6q-1.5-.6-3-1m-14.7 2.7c-.9.7-2 2.4-3 4m-.6-4.5c-2.4 1.3-3.2 3.7-4.4 5.8m2.8 2.8q-2.4-.7-5.3-2m16.7-.7c-2.3-1.2-4.7-1-7.1-1.4m10.8-.4q-5.5-1-10.3-.1m7.8-2.6-1.4-.6m-5.6 5.5-2.3-1.3m57.9-49.2q-1.9 1.4-3.7 3.9m1.8-79.6-2.2-.8"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M474.4 384.9q1.4-1.8 3.3-2.7c7.7-4 15.4-5.8 24-7.2 2.1-.4 4.1-2.3 6.2-3.2 5-2.4 10.5-3.3 15.3-5.7.3-.2 1.5-.9 2-1.6 2-2.2 5.5-2.9 7.6-5 8.4-7.8 17.2-15 21.8-25.5 5.6-12.7 12.5-25.8 11.6-40.2-.6-9.2.7-18.4-1.5-27a105 105 0 0 0-15.4-36.4l1.3.8a104 104 0 0 1 15.4 36.4c2.3 8.6 1 17.9 1.5 27 1 14.4-6 27.5-11.5 40.3-4.6 10.4-13.5 17.6-21.8 25.5-2.2 2-5.6 2.7-7.6 5l-2 1.5c-4.9 2.4-10.4 3.4-15.4 5.7-2 1-4 2.8-6 3.2A77 77 0 0 0 479 383a8 8 0 0 0-3.3 2.7l-1.3-.8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.6 334.6c2.8-7.4 0-24.8-1.4-27-6.7 15.4-3.4 27.6 1.4 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.5 341.6c2.3-5.6.7-19.3-.4-21-5.5 11.7-3.3 21.3.4 21zm16.9-74.1a47 47 0 0 0-19.3-14.6c6.2 13.3 16.5 18.2 19.3 14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.8 259.5a43 43 0 0 0-14.5-16.7c3.1 13 11.4 19.3 14.5 16.7zm4.7 14.9c-3.5-4-15.2-7.9-17-7.7 7 9 15.6 10.9 17 7.7zm-2.8 46.4a40 40 0 0 0 20.3-5.7c-12.9-2.8-21.5 1.9-20.3 5.7zm-.2-5.7c0-5.6-6.3-16.8-8-18-.5 12 4.9 19.5 8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 301.4a50 50 0 0 0-10.6-23.6c-.8 16.2 6.3 25.8 10.6 23.6zm-53 75.3a48 48 0 0 0 22.2 11c-8.8-12.3-20.1-15.1-22.1-11z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#67923d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.6 334.4c-4.9.6-8.1-11.4-1.4-26.8-.5 14.2.2 25.7 1.4 26.8zM500.2 378a50 50 0 0 1 21.9 11.5c-15.1.1-24-7.3-22-11.4zm0-7.9c2-8 15-21.2 17.5-22.1-3.6 17.1-13.7 25.5-17.5 22.1zm21.3-4.1a54 54 0 0 1 7.5-26c3 16.4-3 27.5-7.5 26zm21.5-14.6a49 49 0 0 1 21.6-11.2c-8.9 12.1-19.8 15.1-21.7 11.2zm25.7-53.3c1-6.3 9.7-17.9 11.6-18.9-1.2 13.6-8.3 21-11.6 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 336.2a51 51 0 0 1 24.4-5.5c-11.8 9.7-23.5 9.8-24.4 5.5zm10.3-24.5a44 44 0 0 1 17.7-14.4c-5.8 13-15.3 17.8-17.7 14.4zm-1.5-45.6c0-7.6 8-22.7 10-24.2 1.1 16.1-5.7 26.2-10 24.2zm-6.9-25.9a40 40 0 0 1-.1-20c5.5 10.9 3.7 20 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.6 238a50 50 0 0 1-10.4-22.1c11.8 9.3 14.4 20.4 10.4 22.1zm11.7 34.5c-.3.9 3-7.7 14.2-15.3-4 14.3-11 18.3-14.2 15.3zm-34.1 89.9a61 61 0 0 1 29.2-6.7c-14.2 11.8-28.2 12-29.2 6.7zm14.3-20.8c-3.7.2-6-9.3-.5-21-.7 11-.4 20 .5 21zm16.9-74.1c-2.7 3.6-13-1.2-19.2-14.6a79 79 0 0 0 19.2 14.6zm-1.7-8c-3.1 2.6-11.3-3.6-14.4-16.7 6.7 9.4 13 16.5 14.4 16.7zm4.8 15c-1.4 3.1-9.9 1.3-16.9-7.7 10.4 5.9 14.5 8.4 17 7.7zm-2.6 46.2c-1.3-3.8 7.3-8.3 20.2-5.5a69 69 0 0 0-20.2 5.5zm-.4-5.6c-3.2 1.5-8.5-5.9-8-17.9a69 69 0 0 0 8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.9 301.6c-4.3 2.2-11.3-7.4-10.5-23.5 4.4 12.8 9 22.9 10.5 23.5zm-52.7 75.1c2-4.2 13.1-1.4 22 10.8-11-6.7-20.5-11.3-22-10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#406325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.5 365.8c4.6 1.6 10.5-9.4 7.6-25.9-2.8 14-6.2 25.1-7.6 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.8 360.6a55 55 0 0 0 4.6-27c-10 13.6-9.4 26.3-4.6 27zm-31.7 17.5c-2 4.1 6.7 11.5 21.8 11.3-12-4.8-21.2-9.8-21.8-11.3zm.2-8.1c3.8 3.4 13.8-4.9 17.4-22-8.1 12.4-15.7 21.8-17.4 22zm42.7-18.6c1.8 4 12.7 1 21.7-11.1a84 84 0 0 1-21.7 11.1zm25.8-53.3c3.3 2.1 10.3-5.3 11.5-18.8a75 75 0 0 1-11.5 18.8zM557 336.2c1 4.4 12.5 4.2 24.4-5.5-12.5 4-23 6.2-24.3 5.5zm10.4-24.6c2.5 3.4 11.9-1.4 17.7-14.4a75 75 0 0 1-17.7 14.4zM566 266c4.2 2 11-8 9.8-24-4 13-8.4 23.3-9.9 24zm-7-25.9c3.5.1 5.4-9-.2-20 1 10.5 1 19.1.2 20zm-4.3-2.2c4-1.7 1.4-12.7-10.4-22a82 82 0 0 1 10.4 22zm11.6 34.7c3.2 3 10.2-1 14.2-15.4q-11.8 15.1-14.2 15.4zm-34 89.9c1 5.2 14.9 5 29-6.7-14.9 4.8-27.4 7.6-29 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.1 354.8a41 41 0 0 0 3.6-20.1c-7.5 10-7.2 19.5-3.6 20zm19.6-28.7c3.6-5.7 4-20.9 3-23-8.3 11.9-7.3 22.7-3 23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M531.8 360.5c-4.8-.6-5.3-13.3 4.5-26.8-3.6 13.8-5.4 25.4-4.5 26.8zm35.2-68.3c-1-7.8 4-20.1 6.6-22.5 2.6 14.4-2.7 24-6.6 22.5zm-27.9 62.5c-3.6-.5-3.9-10 3.6-20a67 67 0 0 0-3.6 20zm23.4-104.2c-2.2-6 0-20 1.2-21.8 5.3 12.2 2.6 22.1-1.2 21.8zm-58.1 120.1c2.5-8 16.2-21 18.8-22-4.3 17.5-15 25.6-18.8 22zM559 329a45 45 0 0 1 16.9-15.8c-5 13.6-14.2 19.1-17 15.8zm-.2-3c-4.3-.4-5.3-11 3-22.9a73 73 0 0 0-3 22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M567 294c5.2 1.9 9-9.8 6.6-23.9a98 98 0 0 1-6.6 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M567.8 293.6c.5-7.5-7-23-9-24.7-2 15.8 4.5 26.3 9 24.7zm-5.3-43.2c3.9.4 6.5-9.4 1.2-21.7.4 11.5-.2 20.8-1.2 21.7zm-58 120.1c3.8 3.7 14.4-4.4 18.7-21.8-8.8 12.3-17 21.6-18.7 21.8zm54.6-41.5c2.8 3.3 12-2.1 17-15.8a77 77 0 0 1-17 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M567.7 293.5c-4.5 1.7-10.9-8.7-8.9-24.5 3.5 13.2 7.5 23.7 8.9 24.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ba1f3e",
    stroke: "#511124",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564.6,
    cy: 254.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568.4,
    cy: 266.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 569.8,
    cy: 304.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.6,
    cy: 297.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 549.9,
    cy: 337.2,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.2,
    cy: 339.9,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.8,
    cy: 372.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.8,
    cy: 377.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 557.1,
    cy: 249.3,
    r: 1.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gt_svg__b",
    fill: "#8c959d",
    stroke: "#485654",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.3 336.3c-.2 1 .8 2.3 2 2 .5 0 .7-.5.2-.5q-.7.2-1.2-.3a2 2 0 0 1-.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M437.2 338.3c-1 1.2-2.5 1.7-3.4.9q-1-.9-.5-2l-1 1.3s.6 1.3 1.6 1.8c1.3.5 3-.3 4-1.6.8-1 1.6-2.4 1-3.6a4 4 0 0 0-2-1.7l-1 1q.8-.2 1.7.4c1.3 1 .6 2.5-.4 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "m437.2 338.3-1.1 1q-.7.4-1.5.3l-.7-.3-.5-.6q-.2-.3-.3-.7t.2-.8l.1.1-1.1 1.3v-.1l1 1.3.7.4.8.1a3 3 0 0 0 1.6-.5q.8-.4 1.3-1l1-1.4q.4-.7.3-1.6 0-.4-.2-.8a4 4 0 0 0-1.9-1.6h.1l-1 1.1h-.1q.3-.2.7-.2l.8.2q.7.4.9 1.2.1.8-.2 1.4-.3.8-.9 1.2m0 0q.6-.4.8-1.2t.2-1.4q-.2-.7-.9-1-.7-.5-1.3-.2h-.1l1-1.2a4 4 0 0 1 2 1.7q.3.3.3.8 0 1-.4 1.7-.3.8-1 1.4-.5.7-1.3 1.1-.7.5-1.7.5a2 2 0 0 1-1.6-.6l-1-1.4 1-1.3h.2l-.1.8q0 .3.2.7l.5.5q.2.3.6.3.8.1 1.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    stroke: "#351710",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m515.2 249.3-40.1 39.5L434 328l-4.6 5.4c-2 2.3-4.4 5.3-7.2 8-.5.7-1.1.4-1.7.8-1.8 1-3.7 2.8-5 4.3L403.2 360q-1.2 1.2-.4 2l6.6 8.8c1.2 1.2 2.6 1.8 3.2.8 3.1-5.5 11-13.8 14-20.3 1.7-4 3.9-11.1 5.5-12.8 2-2.2 7.1-7.8 11.8-12.7l1-1q.3-.6.9-1c23.5-24 50.7-53.1 70.5-73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 328.1q-1.7-.2-2.9-1.4c1.2.4 2.4.8 3.5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    strokeWidth: 0.2,
    d: "m557 220.1-31.8 26.2q-.5.5-.9 0l-2.9-2.4v-.6l1.4-1.4q.2-.2-.1-.6l-.6-.6q-.4-.1-.7.2l-1.4 1.5q-1.2.1-1.4 1.4c-19.2 18.7-35.8 35.4-54.9 53.8l-22.6 21.6c-.8 1-4.3 2.9-6.6 4.4q-1.3.8-1.8 1.5l-1.8 5.5c-.6 1.2-2.5 4-2.5 4.2l3.8 3.7 11.1-11.9.9-1a13 13 0 0 0-2.6-2.7l-.7-.5q0-.4.5-.7c26.4-25.6 55-53.7 78.2-76.6h1l2.9 3.1q1 1 1.7.4l31.9-28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "M431 330.4h.6l.5-.1.7-2.4.8-2.4q-.3-.3-.7-.4.4 0 .7.4l-.7 2.4-.7 2.4-.6.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.2,
    cy: 328.1,
    r: 0.6,
    fill: "none",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.4,
    cy: 331.9,
    r: 0.6,
    fill: "none",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    stroke: "none",
    d: "m441 322.4-1.8-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.2 259 3.5 3.5.6-.6-3.5-3.4-.6.6z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt_svg__b",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)rotate(-2.8 -9.3 19640.2)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M434 365.4a56 56 0 0 0-29.3.9c16.3 8 29.5 4.6 29.2-1zm89 3.3c7.8-3.3 26.8-.7 29.1 1-16.2 7.9-29.5 4.5-29.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M433.8 365.5c.3 5.5-12.8 8.9-29.1.9 15.3 1 27.8.4 29-1zm89.2 3.3c-.2 5.5 12.9 8.9 29.2.9-15.3 1-27.8.4-29.1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gt_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b6ba",
    stroke: "#485654",
    strokeWidth: 0.2,
    d: "M508.5 360a238 238 0 0 0-76.1-68c3.5-.2 11.4 3.9 14.7 6 23.9 15.4 44.3 35.8 65.6 59.8-1.2 1.2-2 2-3.4 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c959d",
    d: "M510.6 359.8 509 361c-23-29.6-55-57.9-76.7-69 30.1 13.8 55.4 41.7 78 67.6h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#485654",
    d: "M510.6 359.8 509 361a303 303 0 0 0-35.2-38 285 285 0 0 0-30.4-24.3q-5.4-3.6-11.1-6.7v-.2q12 5.6 22.5 13.3 10.5 7.6 20 16.6a360 360 0 0 1 18.3 18.5q8.9 9.7 17.4 19.5zm0 0q-8.6-9.9-17.5-19.4a355 355 0 0 0-18.3-18.5q-9.5-8.9-20-16.6t-22.4-13.2v-.2a196 196 0 0 1 21.7 14.3 285 285 0 0 1 38.2 35.1 314 314 0 0 1 16.8 19.8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fab81c",
    stroke: "#6c301e",
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.2,
    d: "M517.5 355q-3 .9-5.3 2.3c-.2 1.4-2 3-3.5 3.3l-.6-.8h-.2l-.6.3q-1-.1-1.6 1c-.4 1 .3 2.3 1.2 3.1 1 .7 1.4 1 2.4 1 1.1-.3 1.7-1.3 2-1.6 3.7 4.5 6.5 7 11.2 10.6 2.1 0 3.2-1.3 2.5-2.8q-.4-.8-1.3-.6v-.5c2.4-2.2 3.5-5 .9-9.8-2.2-4-4.7-5.4-7-5.4h-.1zm6.2 4.6q.7 1 1 2c1.6 3 .3 6.7-2.3 7.8h-.2c.4-.7-.8-2.2-1.4-1.7.3-.7-.7-2-1.5-1.7.4-.7-.5-1.9-1.4-1.5.4-.7-.3-1.8-1.3-1.6.3-.8-.4-1.8-1.3-1.6q0-1.1-.5-1.5c1-.8 2.3-2.1 3.4-2.7 2.7-1.2 4.4 1 5.5 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.9 362.8q-.8-.6-.6-1.1.4-.6 1.2-.2t.7 1q-.4.6-1.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.6 361.8q-.8-.5-.6-1.2.4-.5 1.2-.1t.7 1q-.4.6-1.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 360.6q-.8-.4-.6-1 .4-.6 1.2-.3.8.6.6 1.1t-1.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.2 359.6q-.8-.5-.6-1.1.4-.5 1.2-.2.8.6.7 1.1-.4.6-1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.2 358.6q-.9-.5-.6-1v-.2c.2.1.7.2.6-.1v-.2l.6.2q.8.6.6 1.1t-1.2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fab81c",
    d: "M511.3 363.6c.7-1.8 2-3.4 3.5-3.8m-3.3 4.1c1.3.2 3.3-1.3 3.8-2.6m-2.6 4c1.6.4 3.3-1.2 4-2.4m-2.5 4c2 0 3.1-1.3 3.7-2.4m-2.2 3.9c1.7 0 3.2-1.3 3.6-2.4m-2.2 3.8q2.8-.2 3.7-2m-2 3.4c1.7.1 3-.9 3.4-1.8m-1.6 3.3c1.6 0 2.7-1 3.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6c301e",
    d: "M511.3 363.6a7 7 0 0 1 2.3-3.2q.4-.4 1.2-.6l-1.2.6-1 1a8 8 0 0 0-1.3 2.2m.2.3q.6 0 1.2-.2l1-.6 1-.8.6-1-.6 1a5 5 0 0 1-2 1.4q-.6.3-1.2.2m1.2 1.4h1.2l1-.6a6 6 0 0 0 1.7-1.8l-.7 1-.9.9-1 .5zm1.5 1.6q.6 0 1.1-.2l1-.5 1-.8.6-1a4 4 0 0 1-1.5 1.9l-1 .5zm1.5 1.5q1.2 0 2.1-.8a5 5 0 0 0 1.5-1.6q-.1.5-.6 1l-.8.7-1 .6zm1.4 1.4q.6 0 1.1-.2a5 5 0 0 0 2-1l.6-.9-.6 1q-.4.4-1 .6-1 .6-2 .5zm1.7 1.4a5 5 0 0 0 2-.5l.8-.5q.4-.4.6-.8-.1.5-.5.8a4 4 0 0 1-3 1zm1.8 1.5 1-.1.8-.4.7-.6.6-.8a3 3 0 0 1-3.1 1.9"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt_svg__c",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)rotate(-3.4 -13.8 16470.8)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M409.2 240a52 52 0 0 0 19.5-17.9c-15.6 4.2-22.7 14.3-19.5 18zm145.8 4.7a50 50 0 0 0-15.6-19.9c2.8 15.2 12 22.8 15.6 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M409.2 240c-3.3-3.6 3.8-13.6 19.4-17.8-11 8.4-19.2 16.2-19.4 17.8zm145.8 4.7c-3.7 3-12.7-4.6-15.5-19.7 7.2 11 14 19.5 15.5 19.7z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#999270",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__d)",
    d: "M452.2 318.1s-6.1.7-7.9-7.8c-1.8-9.1 5.3-10 5.3-10s8.1-.9 13.2-1l2.2 18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__e)",
    d: "M453 315.4s-4 .7-4.8-5.6c-.6-4.5 2.2-5.1 2.2-5.1l9.2 1.6v8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__f)",
    d: "M450.4 304.7s6-.4 9-.8l1.3 5.7-7.1.4s-.5-5.1-3.2-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__g)",
    d: "M449.2 300.4s7.5-1.9 8.5 6.4c.2 2.2-1 7.2-4.7 8.6l13.9-1.5-1.3-15-4.6.4s-10 .3-11.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9f0aa",
    d: "M452.2 318.1s51.9-3.5 57.2-3.3c15.8-8.6 0-42.5-13.3-61.5 1.5-4.3-29.9-13.9-44-13q-2.8 0-5.2.3c-7.7.8-7.8 10.7-4.7 17 3 6 30.4 55 11.2 60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__h)",
    d: "M507.8 273.3c-3.5-7.3-7.7-14.3-11.7-20 1.5-4.3-29.9-13.9-44-13q-2.8 0-5.2.3c-7.7.8-7.8 10.7-4.7 17 1 1.8 4.3 8 7.9 15.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__i)",
    d: "M455 285c5.6 14.6 8.7 30-1.6 32.9l-1.2.2s52-3.5 57.2-3.3c8.6-4.7 7.8-16.8 3.2-30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__j)",
    d: "M447.4 243.5c-3.7 0-4.7 3.6-4.6 5.8.1 6 4.6 6.2 4.6 6.2l6-.3 2.8-12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__k)",
    d: "m447.4 243.5 8.8-.5 1 9.1-7.8.4s2.5-7.3-2-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__l)",
    d: "M496.1 253.3c6.7-1 6.6-10 2-13.7-15.5-.6-35.8-.1-50.6 1 1.7 0 6.4.4 6.9 6.5a8 8 0 0 1-3 7 7 7 0 0 1-4 1.4h3.6l3-.4c21-2.7 42-1.8 42-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b07e09",
    stroke: "none",
    d: "M458.5 267.4q-.2-.5-.8-.8-.5.1-.5-.4h.8l1.6-.2q.5.3 0 .5c-.5 0-.2.5-.1.8l1.3 3q.2.6.7.7l1.1-.1q.3-.4.2-1c-.1-.3.5-.2.5 0l.4 1.4q0 .2-.4.1l-3 .2c-.3 0-.8.3-1 0 0-.4.6-.2.6-.5l-.3-1zm4.8-.4q-.1-.4-.7-.7-.5.1-.6-.4.3-.2.7 0l1.7-.2c.3 0 .4.5 0 .4q-.4.1-.2.7l1.5 3.4q0 .4.5.6.4 0 .7.3-.1.3-.6.1-.7 0-1.6.2-.4 0-.5-.3c-.1-.3.5 0 .6-.4q0-.4-.4-1l-1.1-2.6zm4.5.8q.2.2.5 0 .5 0 .6-.4 0-.8-.7-1.2-.5-.3-1.1-.2l.1.5zm.6 1.6q.2.5.6 1 .4.2.8 0 .5-.1.4-.5-.1-1.1-1.2-1.5h-1l.2.5zm-2-2.4q-.2-.6-.7-1-.4.1-.7-.2c0-.3.6-.1.8-.2.9 0 1.8-.3 2.6 0q1.2.4 1.5 1.6 0 .6-.6.8l.5.1q1 .3 1.4 1.2.4.6 0 1.3-.7.5-1.4.4-1.1 0-2.3.2c-.3 0-.4-.5 0-.5q.4-.1.2-.6l-1.3-3zm7.4-1.9q.4.1.5.5l.3.9q-.4.1-.6-.4-.3-.4-.7-.4h-1.2q-.2.3.1.6l.6 1.4q.4 0 .8-.3c0-.2-.3-.7.2-.6q.3.4.4.9l.5 1.1c-.3.3-.5-.1-.6-.4q-.4-.4-1-.3-.1 0 0 .3l.6 1.5q.4.4 1 .3.6.1 1-.4c.2-.2-.3-.7 0-.8q.5.1.5.6t.3.8q-.1.3-.4.2l-3 .2c-.4 0-.9.2-1-.2 0-.3.7-.1.6-.5l-.4-1-1.1-2.7q-.2-.6-.8-.7c-.2 0-.6 0-.4-.4h1zm2.3 1.3q-.1-.5-.7-.9-.5.1-.7-.4.5-.1 1 0c.8 0 1.6-.3 2.4 0q1.3.3 1.6 1.8 0 .6-.7.8c-.3 0 .2.1.3.2q1 .5 1.4 1.5c.1.2.5.7.6.2s.6 0 .5.3q-.1.6-.7.6t-1.1-.6q-.5-1-1.3-1.7a1 1 0 0 0-.8-.2v.5l.6 1.2q.4.4 1 .3c.3.1.2.6-.2.5h-1.7c-.3.2-.9 0-.7-.3q.6 0 .5-.5l-1-2.6zm1.4 1q.4.1.9 0 .4-.2.2-.7-.2-.8-.9-1.2c-.2 0-.8-.2-.9.1l.7 1.6zm7.2 1.6q.2.5.6.7.4 0 .7.3-.1.3-.6.2h-1.6q-.5.2-.6-.3c.2-.2.7 0 .7-.4l-.5-1.1-1.1-2.9q-.3-.4-.7-.3-.6-.1-.7.4.2.5 0 .8-.4-.1-.5-.5t-.4-1q.2-.2.5-.1l4.2-.2q.5 0 .5.5l.4 1q-.3.3-.6-.3t-.9-.7q-.4 0-.8.2l.2.7zm3.8-.9q-.2.1-.1.4v.8q.3.4.8.4c.2 0 .1.5-.2.4h-1.2c-.3.1-.8-.1-.5-.4q.3 0 .5-.3v-5q.4-.3.6.2l3.6 4.5q.3.4.8.4c.3 0 .4.5 0 .4h-1.5q-.4.1-.7 0-.2-.3.2-.4c.3 0 0-.4-.1-.6l-.6-.8zm1.1-.5q.2 0 0-.2l-1.3-1.7v2h1.3zm3.1-1.8c-.1-.4-.3-1-.8-1q-.6 0-.5-.4h1.7q1-.2 2 .1 2.4.9 3 3.4 0 1-.6 1.6-1.2.6-2.5.3l-1.4.1c-.3 0-.4-.5 0-.4q.5-.2.2-.7zm2 2.5q.1.5.5 1h1q.7-.2.7-.9a5 5 0 0 0-.6-2.1q-.6-1-1.8-1.4h-1v.4zm-21.1 12.4q.1.5.8.6c.2 0 .7 0 .7.4q-.4.2-.8 0l-1.5.2h-.9q-.3-.2.1-.4.5 0 .6-.4l-.2-.8-1.2-2.8q-.1-.4-.7-.3-.4.1-.7-.2c0-.3.5-.2.7-.4l1-.3q.3 0 .3.3zm.7-4.5h2c.4 0 .2-.5.4-.5q.5.2.4.7 0 .7-.6.6H475l.5 1.2.6-.2c1 0 2.2.6 2.6 1.6q.4.8 0 1.5-.6.7-1.6.6-.8 0-1.4-.6c-.1-.2-.1-.7.2-.6q.7 0 .7.6.3.2.7.1.5 0 .6-.5 0-.8-.5-1.4-.3-.6-1.3-.7l-.8.1q-.4-.1-.4-.5l-.7-1.9.2-.1zm6.9 1q-.2-.7-.9-1c-.2 0-.7-.1-.4-.4h1.6q1.1-.2 2.1.1 2.4.9 3 3.4.1 1-.7 1.6-1.1.4-2.4.3l-1.3.2c-.3 0-.4-.5 0-.5q.4-.1.2-.7zm2 2.5q.2.5.6 1h1q.6-.3.6-1 0-1-.7-2.1t-1.8-1.3h-1v.4zm6.4-4.3q.4.1.5.5t.3.8q-.4.3-.6-.3-.1-.4-.6-.5h-1.3q-.1.4 0 .6l.6 1.4q.5 0 .8-.2c.2-.2-.3-.7.2-.6q.4.2.4.8l.5 1.1c-.1.4-.5 0-.6-.3q-.3-.4-.8-.3-.4 0-.2.2l.6 1.5q.4.4 1 .3.7 0 1-.3c.2-.2-.2-.6 0-.8q.6.1.5.5l.3 1h-.4l-3.1.2q-.5.2-.9-.1c-.2-.4.5-.2.6-.5l-.3-.9-1.1-2.9q-.2-.5-.8-.7c-.2 0-.6 0-.4-.4h1zm-27.2 14.3q.3.7 1 .8 1.3.3 2.2 1.1.5.6.5 1.4-.1.8-1 1-.8.3-1.7-.1c-.2-.1-.1.4-.5.3q-.2-.4-.2-.9l-.4-1q.2-.3.5.2.5 1 1.6 1.1.7 0 .8-.6-.1-.8-.8-1.2-1-.3-2-.8a2 2 0 0 1-1-1.6q.1-.7.8-.9t1.6 0q.2-.2.6-.1 0 .3.2.6l.3.9q-.4.2-.5-.2-.4-.7-1-.8-.6 0-1 .3zm6.6-1.7q.5.1.5.5l.2.8q-.2.3-.5-.2-.1-.4-.7-.5h-1.2q-.1.4 0 .6l.5 1.4q.5 0 .8-.2c.2-.2-.2-.6.1-.7q.5.2.5.7.1.6.4 1.3-.3.3-.5-.3-.2-.4-.8-.3-.4 0-.3.2l.6 1.5q.2.4.7.3.7 0 1.2-.3.1-.4 0-.8.5-.2.6.3l.2 1q-.1.3-.4.2l-3 .2c-.4 0-.8.3-1 0 0-.4.5-.3.6-.6q0-.3-.2-.8l-1-3q0-.5-.7-.6-.5 0-.4-.4h1zm4.2 4.2q.2.5.6.7.6-.1.8.2c0 .4-.5.2-.7.2q-.8 0-1.6.2-.4 0-.6-.2c0-.4.5-.2.6-.4l-.1-.8-1-3q-.2-.6-.7-.7-.5.1-.5-.4.2-.1.7 0 1-.2 2.2-.2a2 2 0 0 1 1.7 1.2q.3.7 0 1.3-.8.5-1.7.6-.2 0 0 .3zm-.6-1.8h.7q.5-.2.4-.7 0-.7-.5-1.2t-1.1-.2q-.1.2 0 .5zm6.2 1.5q0 .4.5.6.5 0 .7.3c.2.3-.5.2-.7.2l-1.6.1q-.4 0-.5-.3c.2-.2.7 0 .7-.4l-.3-1.2-1-2.9q-.1-.3-.7-.2-.4 0-.7.3v.8q-.4.2-.4-.3l-.4-1q.1-.3.5-.3l4.1-.2q.5 0 .5.5l.4 1q-.3.2-.5-.2-.3-.6-1-.7h-.8l.2.7zm2.1-3.3q0-.6-.6-.8-.4.1-.6-.4.2-.1.6 0l1.8-.2c.3-.1.5.4.2.4s-.6.2-.5.5l.5 1.6.7 2.2q.1.3.5.4.6-.1.6.4h-.7l-1.6.2c-.2 0-.6-.2-.4-.4q.5 0 .6-.4l-.3-1.2zm5.8-1.6q.4.1.4.5l.2.8q-.3.3-.5-.2-.1-.5-.7-.6H485q-.1.4 0 .7l.5 1.3q.3 0 .8-.2c.2-.1-.2-.6.1-.6q.5.1.5.6.1.7.4 1.3-.3.3-.5-.2t-.8-.4c-.1 0-.5 0-.3.2l.5 1.5q.3.4.7.4.7 0 1.2-.3.1-.4.1-.9.5-.1.5.4l.2 1q0 .3-.4.2l-3 .1q-.6.1-1 0c-.1-.4.5-.3.6-.5l-.1-.8-1-3q0-.6-.7-.7c-.2 0-.6-.2-.4-.4h1l2.9-.2zm2 1q-.2-.6-.8-.7c-.3.1-.5-.6 0-.4h1.5l.7.9 2.2 2.9q-.1 0-.1-.3l.4-3.6c.2-.2.7 0 1-.2.3 0 1 0 .8.4q-.7 0-.6.6l1.2 3.6q.1.6.8.5c.3 0 .3.6 0 .5H494q-.7.2-.7-.3c.3 0 .8-.2.6-.6l-1-3.2v.4l-.2 3-.1.8q-.4 0-.5-.3l-2.9-3.7.2.3q.4 1.5.9 2.9.2.5.8.5.4.4-.2.4h-1.5q-.4-.2 0-.4.6-.2.2-.8zm8.7.8q.2.1.5 0 .5.1.7-.4 0-.7-.5-1.2-.6-.3-1.2-.2v.5zm.5 1.6.4 1q.5.2.9.1.4 0 .4-.5 0-1-.9-1.5h-1v.3zM496 288q0-.6-.6-1-.5 0-.6-.3c-.1-.3.5 0 .7-.1q1.4-.1 2.7 0 1.2.4 1.3 1.6-.1.6-.7.9.2-.1.5 0 .8.3 1.2 1.2.4.6 0 1.3-.7.5-1.5.4l-2.3.1c-.3 0-.4-.5 0-.4q.5-.1.2-.7zm5.1-.2q0-.6-.6-1-.5 0-.6-.3c.2-.3.6 0 1-.1h2q1.3.1 1.7 1.4.2.8-.4 1.2l-.4.2q1 .4 1.4 1.2l.5.8q.3.1.3-.3c.4-.2.6.3.4.6q-.4.6-1 .4a1 1 0 0 1-.8-.6l-1-1.7q-.5-.3-.9-.1v.4l.5 1.2q.3.4.8.4c.4 0 .4.5 0 .4h-1.8q-.4.1-.7 0c-.2-.5.4-.3.6-.5l-.2-.9zm1.3 1c.1.3.6 0 .8 0q.5-.1.4-.5 0-.8-.5-1.3-.5-.3-1-.1-.2.1 0 .5l.3 1.3zm6.9-2.6q.4.1.4.5t.3.8q-.4.3-.6-.2 0-.5-.6-.6h-1.3q-.2.2 0 .6l.4 1.4q.5 0 .8-.2c.3-.1-.1-.5.2-.7q.5.1.4.7.1.7.4 1.3-.3.3-.5-.2-.1-.5-.7-.4c-.1 0-.5-.2-.4 0l.5 1.7q.2.4.7.3.7 0 1.2-.2.1-.4.1-.8.6-.2.5.3l.2 1q-.1.3-.4.2h-3.1q-.5.1-.8 0c-.3-.4.2-.3.4-.5s0-.5 0-.7l-.9-3.1q0-.6-.6-.7-.8 0-.5-.4h1zm-32.8 13.1q0-.6-.6-1-.6 0-.5-.3l1-.1q1.2-.1 2.4 0 2 .5 2.6 2.3.4 1.2-.2 2.3-.9.9-2.2.8-1 0-1.9.2c-.2.1-.6-.1-.4-.4q.6 0 .6-.5l-.4-1.5zm1.6 2.5q.1.5.4.9.5.2 1 0 .7 0 .9-.9a4 4 0 0 0-.4-2.2 2 2 0 0 0-1.5-1.2h-1.1v.4zm7.1-4.5q.4.1.4.5l.2.9q-.4.2-.5-.2-.2-.5-.6-.6h-1.3q-.2.2 0 .6 0 .8.3 1.4.5 0 .8-.2c.2-.2-.1-.6.2-.7q.4.2.4.7l.3 1.3c0 .3-.5 0-.5-.2q-.1-.5-.7-.4c-.1 0-.5-.1-.3.1q0 .7.4 1.6.1.4.7.3.7 0 1.2-.3l.2-.8q.3-.2.4.4 0 .4.2 1-.2.2-.5.1l-3 .2q-.5.2-.9 0-.2-.4.4-.4.4-.3.1-.7l-.7-3.2q-.2-.6-.6-.7-.6 0-.5-.4h1zm6.5 4.1q0 .5.6.7.4 0 .7.2c.1.3-.4.2-.6.2l-1.7.1h-.8q-.4-.2.1-.4.5 0 .7-.4l-.1-.8-.7-2.8q0-.4-.6-.3-.4.2-.7-.1c0-.4.5-.3.7-.4l1.1-.4q.3 0 .3.3zm3.7-3.3q0-.7-.7-.8-.6 0-.8.3-.2.6.4 1l.9.5.2-.6zm.8 2.9q-.2-.7-1-1-.3-.1-.5-.1a1 1 0 0 0-.4 1q.3 1 1 1 .6.2 1-.4v-.5zm1-.2q0 .8-.6 1.3-.8.5-2 .2-.9-.2-1.2-1.2 0-.8.5-1.4c.1 0 .5-.1.2-.2q-.9-.3-1-1.2-.3-.8.5-1.3a2 2 0 0 1 2.6.7q.3.7 0 1.2l-.6.5q.8.1 1.2.8.3.2.3.6zm3.2.6q.4 0 .5-.4c.1-.2 0-.7.3-.6q.3 0 .3.6.1.6-.4 1.1-.3.2-.8.1h-1.7q-.4.2-.7 0-.1-.3 0-.7.4-1 1-1.6.7-.4.8-1.1 0-.6-.2-1.2a1 1 0 0 0-1.4-.3q-.5.3-.3.7c.2.2.6 0 .7.4q.2.5-.3.6t-1-.7q-.2-.9.6-1.4t1.7-.2 1.2 1.2q.2.6-.1 1.3-.8.9-1.7 1.7-.2.2-.1.6.2-.3.5-.2zm3.9-.4q0 .4.6.6.4 0 .7.2c.2.3-.3.3-.5.3h-2.7q-.2-.4.2-.4t.7-.4v-.8l-.7-2.8q-.1-.4-.5-.3t-.7 0c-.2-.4.3-.4.5-.5l1.2-.4q.4 0 .4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#448127",
    stroke: "#34541f",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gt_svg__m)",
    stroke: "#4c0505",
    d: "M475.8 219.4 472 224c-1.2 5.2 1.8 9.2 7.7 12.6 4.7 3 13.5 3.7 16.3 1.3l-13.7-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.6 354.3-2-2.5a101 101 0 0 1-32.7 28.6c15.1-4.2 25-15.2 34.7-26.1zM488.1 390a456 456 0 0 1 18.2-32.3l-2.1-2.7c-7.4 12.2-16 26.7-16 35zm41.8-114.5a62 62 0 0 0-4.3-13 127 127 0 0 0-43.8-44v-.3h.4l-.1-.1h.4l-.2-.3h.4l-.3-.4h.4l-.3-.3h.5l-.3-.4h.4l-.4-.3.6-.1-.5-.3.5-.1-.4-.3.6-.2-.5-.3.6-.3-.6-.4.7-.2-.8-.3.7-.4h-.8l.5-.7h-.7l.3-.5h-.6l.3-.5-.7.1.3-.6-.6.4.2-.7-.7.4.1-.7-.6.5.1-.7-.5.5v-.7l-.5.6v-.7l-.4.5-.2-.6-.4.6-.1-.7-.3.7-.2-.7-.3.7-.2-.6-.2.6-.2-.6-.2.8-.2-.7-.3.8-.3-.7v.8l-.4-.7v.8l-.5-.6v.8l-.4-.6v.7l-.4-.3.2.7-.5-.3.2.6-.4-.2.1.6h-.4l.2.4h-.3l.2.4a9 9 0 0 0-.4 3.5c0 .2.6.4.7.6q.3.6.2.6c-1.6 2.6-3 4.6-3.1 7.6 1.2-1.6 2.6-3.6 4.4-3.6-.9 1.5-1.3 6.1-.3 6.8l.8-1.3q0 1.5.4 2.3.4-1 1-1.7 0 2.3.6 3.3.7-1.1 1.6-1.6-.4 1.3-.3 2.7.9-1.4 1.9-2.5c-.4 1.6 0 2.8.4 4.5.4-2 .6-2.3 1.5-3.1.1 1.9-.2 3.6.2 4.7.8-1.7 1.4-1.5 2-2.6-.2 1.6-.5 3.3 0 4.7a5 5 0 0 1 1.9-2.6c0 2.2.5 1.8-.8 3.7.6.2 2.5-.4 3.6-.9-.5 1.2-.4 2.1-.9 3q1.5-1 2.9-2.4c-.4 1.4-1.5 2.8-1 4.1q.6-2 2.3-2.5c-.2.7-.3 2.2-1.3 2.9 2.4.2 3.4-1.4 4.6-2.7-.1 1.3 0 2.4 1.6 4.3-.3-2.4.2-1.9 1.3-3.3.6 2.1 1.2 4.4 3.4 6-1-2.3-1-3.5-.6-4.9.3 1.5 1.7 3.3 2 4.6q.3-2.4 1-4a20 20 0 0 1 1.4 5.6q.8-1.5 1.1-3c19.8 20.5 24.2 46.7 2.5 74.4 7.8-5.2 9.8-13.5 14.1-20.6-4.2 9.3-6 19.7-13.5 27.4 7.2-6.2 8.7-11.9 13-17.9-4.5 12.5-11 26.2-19.8 38.8l4.8 5.2 4-6.9c9.4-15.4 24.7-37.5 17-71.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    stroke: "#a08307",
    strokeWidth: 0.2,
    d: "M473.2 215.3c-1 .2-1.4.6-2.2 1.4q1.4.3 2.6.3.3-.2.3-.6l-.2-1c0-.2-.6-.1-.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a08307",
    d: "m471 216.7 2.2-.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.7,
    cy: 215.4,
    r: 0.8,
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 477.9,
    cy: 215.3,
    fill: "url(#gt_svg__n)",
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#34541f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.2 389.7a83 83 0 0 1 7.4-17.2 200 200 0 0 1 7.1-12.2l2.6-4-2.5 4-7 12.3a134 134 0 0 0-7.6 17zm-18.9-9.5a76 76 0 0 0 29.7-23.1 154 154 0 0 0-11.2 11.8 70 70 0 0 1-18.5 11.3m37.3-29.3q1.2-1.6 2.2-3.3a136 136 0 0 0 6-10.2q2-3.5 3.8-7l3.7-7-1.7 3.5-1.8 3.6a256 256 0 0 1-7.7 13.8zm5.9-25.1a58 58 0 0 0 8.5-13.4 73 73 0 0 0 6-23l-.1 4a59 59 0 0 1-5.8 19 60 60 0 0 1-8.6 13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.9 320a52 52 0 0 0 8.7-12.5A96 96 0 0 0 524 297l.3-.9.3-.9.6-1.8a42 42 0 0 0 .2-15.4 58 58 0 0 0 .7 7.7q0 4-.7 7.7-.4 1-.6 1.9l-.3.9-.4.9-4.4 10.6a52 52 0 0 1-3.8 6.6 36 36 0 0 1-5 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 349.2q1.9-2.4 3.6-5l1.8-2.5 1.7-2.5 3-5.4 2.6-5.5q2.7-5.5 5-11.3a79 79 0 0 0 5.3-23.8 58 58 0 0 0-2.6-24.2 52 52 0 0 1 2.8 24.2 80 80 0 0 1-5.3 23.9q-2.3 5.7-5 11.2l-2.8 5.5q-1.3 2.8-2.9 5.4-.8 1.4-1.7 2.6l-1.8 2.5-3.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.8 352.3a443 443 0 0 0 13.4-23.5 82 82 0 0 0 8.7-39.2q0-6.8-1.2-13.4h.1q1.3 6.7 1.2 13.4a103 103 0 0 1-3.6 26.7 82 82 0 0 1-5 12.6 443 443 0 0 1-13.5 23.4zM480 220.8h1.4a14 14 0 0 1 4.1 1.3 36 36 0 0 1 9 6.8 38 38 0 0 0-9-6.6 19 19 0 0 0-5.5-1.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#448127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.4 231.6s3 1.8 4.7 4.4c0 0-4.7-.9-8-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M496.4 231.6a14 14 0 0 1 4.8 4.4l.1.2h-.2a15 15 0 0 1-4.4-1.8q-2-1.2-3.7-3a15 15 0 0 0 5.9 3.8l2.2.7v.2a11 11 0 0 0-2.2-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.6 230.7s7.2 4.6 8.3 5c0 0-1.7-3.5-5.1-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m489.6 230.7 4.1 2.5 3.1 1.8 1 .6v.1a11 11 0 0 0-2.1-2.9 11 11 0 0 0-2.9-2.1 8 8 0 0 1 3 2 11 11 0 0 1 2.1 3l.2.2-.3-.1-2.1-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.5 228.4s3.7 1.6 4.6 4.3c0 0-6.8-2.8-8-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M492.5 228.4a11 11 0 0 1 2.8 1.6l1.1 1.2.8 1.5v.2h-.2a77 77 0 0 1-7-3.7l-.9-.8.9.7 1 .6a36 36 0 0 0 6.1 3h-.1q-.2-.7-.8-1.3l-1-1.2a11 11 0 0 0-2.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.8 231.3s6.6 4.7 8.6 4.7c0 0-2-3.3-5.4-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m486.8 231.3 7.4 4.3 1.2.3-.1.2a12 12 0 0 0-2.3-2.8 13 13 0 0 0-3-2 11 11 0 0 1 4.4 3.2l1 1.5.2.1h-.2q-.7 0-1.3-.3l-1-.5a33 33 0 0 1-6.3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.8 232.7s3.4 3 5.4 3c0 0-2-3.3-5.4-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "m486.8 232.7 4 2.5.6.2.8.2-.1.1a12 12 0 0 0-2.3-2.7 13 13 0 0 0-3-2 11 11 0 0 1 4.4 3.1l1 1.5.2.2h-.2l-1.6-.4a12 12 0 0 1-2.6-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 226.2s7.2 5.1 8 7.9c0 0-6.4-3-7.6-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34541f",
    d: "M485 226.2a52 52 0 0 1 7.5 6.6l.7 1.2v.3l-.2-.1-6.8-3.9-.8-.7.8.7 1 .6a37 37 0 0 0 6 3l-.2.2-.7-1.2a29 29 0 0 0-5-5z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#24420e",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#406325",
    d: "M445 370.3a42 42 0 0 1-20.4 4.8c10-8.2 19.7-8.4 20.4-4.8zm69.8 4.5c5.2 4.7 21 8 23.5 7.4-10.6-10.7-22.1-11.8-23.5-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67923d",
    d: "M445 370.3c-.7-3.7-10.5-3.4-20.4 4.8a70 70 0 0 1 20.4-4.8zm69.9 4.4c1.4-4.4 12.8-3.3 23.4 7.5a84 84 0 0 0-23.4-7.5z"
  })))));
};
export default SvgGt;